import { Link } from 'react-router-dom'
import useAuth from '../../../hooks/useAuth'

import logo from '../../../assets/images/logo-new.png'

const MobileLogo = () => {
    const { isAdmin } = useAuth()
    return (
        <>
            <div
                className={`${
                    isAdmin() ? 'mr-8' : ''
                } flex gap-1 justify-center flex-grow flex-wrap`}
            >
                <Link to="/">
                    <img
                        src={logo}
                        alt="mobile-logo"
                        width="280"
                        height="280"
                    />
                </Link>
            </div>
        </>
    )
}

export default MobileLogo
